<lx-form-field-selector
  [small]="small"
  [label]="label"
  [value]="value"
  valueExpr="code"
  [disabled]="disabled"
  [itemList]="countriesOfResidence"
  [required]="required"
  [buttonView]="false"
  [placeholder]="placeholder"
  [sortCriteria]="sortCriteria"
  [iconValidation]="iconValidation"
  (valueChange)="dirty = true; valueChange.emit($event)"
  (dropdownClosed)="dropdownClosed.emit()"
></lx-form-field-selector>
